import { Destructable, Model } from "@models";
import { Service } from "./base-service";
import { InitService } from "@core-services/init.service";
import { DestructorService } from "@core-services/destructor.service";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";

@UntilDestroy()
export abstract class ListService<M extends Model, S extends Service<M>> extends Service<M> implements Destructable {
	protected _services: S[] = [];

	protected constructor(
		protected initService: InitService,
		protected destructor: DestructorService,
		name
	) {
		super(initService, destructor, name);
		destructor.register(this);
	}

	protected addSubForList(services: S[]): void {
		services.forEach((service) => this._services.push(service));

		this._services.forEach((service) => {
			service
				.getList()
				.pipe(untilDestroyed(this))
				.subscribe(() => {
					const list: M[] = [];
					this.services.forEach((s) => list.push(...s.list));
					this.list = list;
				});
		});
	}

	public serviceForObject(a: M): S {
		return this.serviceForId(a.getId());
	}

	public serviceForId(id: string): S {
		return this.services.find((s) => s.list.some((m) => m.getId() === id));
	}

	public destroy(): void {
		super.destroy();
	}

	public get services(): S[] {
		return this._services;
	}
}
